import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  QaiBreadcrumbListComponent,
  QaiFieldComponent,
  BreadcrumbItem,
  QaiInnerWrapComponent,
  QaiMultiSelectComponent,
} from '@qai/ui';
import { ITeam } from 'src/app/interfaces/reportingV2/iteams';
import { EntityOption } from 'src/app/interfaces/reportingV2/ientity-option';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { LocaleService } from 'src/app/services/locale.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslocoModule } from '@jsverse/transloco';
import { AccountEntityUtil } from 'src/app/utils/account-entity-util';

@Component({
  selector: 'app-personalized-practice-header',
  templateUrl: './personalized-practice-header.component.html',
  styleUrls: ['./personalized-practice-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    QaiBreadcrumbListComponent,
    QaiFieldComponent,
    QaiInnerWrapComponent,
    QaiMultiSelectComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    },
  ],
})
export class PersonalizedPracticeHeaderComponent implements OnInit, OnChanges {
  @Input() heading: string = '';
  @Input() teamOptions: ITeam[] = [];
  @Input() selectedTeams: string[] = [];
  @Input() isLoadingTeams: boolean = false;

  @Output() teamChange = new EventEmitter<string[]>();

  isTranslationLoaded = false;
  allTeams = { enable: false, option: { value: '', label: '' } };
  searchOptions: EntityOption[] = [];

  constructor(
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    private localeService: LocaleService
  ) {}

  ngOnInit(): void {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      this.searchOptions = AccountEntityUtil.formatEntities(this.teamOptions);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teamOptions']) {
      this.allTeams = {
        enable: true,
        option: {
          value: 'all',
          label: this.translocoService.translate(
            'ALL_TEAMS',
            {},
            'reportingV2'
          ),
        },
      };
      this.searchOptions = AccountEntityUtil.formatEntities(this.teamOptions);
    }
  }

  getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      {
        text: this.translocoService.translate('reportingV2.DASHBOARD'),
        href: '/reporting_dashboard',
      },
      { text: '', href: '', active: true },
    ];
  }

  onTeamChange(teams: string[]) {
    this.teamChange.emit(teams);
  }
}
